import { createFileRoute } from "@tanstack/react-router"
import { HomePage } from "@/components/pages/HomePage"
import { fetchExploreGuides } from "@/lib/explore-data"
import { defaultMeta } from "@/lib/seo"

export const Route = createFileRoute(`/_public/`)({
  ssr: true,
  // The home page is zero-hydration (no <Scripts/> — see guide-ssr.ts), so its
  // featured-guides grid can't come from a client useQuery (it would be a
  // permanent skeleton). Server-render the same published set the explore hub
  // uses — direct Postgres, never throws, degrades to []. Mirrors explore.tsx.
  loader: () => fetchExploreGuides(),
  head: () => {
    const meta = defaultMeta({
      // Homepage targets the "collaborative/group trip planner" query family;
      // the "ai trip planner" head terms live on /ai-trip-planner.
      title: `Collaborative Trip Planner for Group Travel`,
      description: `ChicTravel is a collaborative trip planner for groups — every stop lands on a live map, your whole crew edits it together in real time, and Chic, your AI copilot, helps with the drafting.`,
      path: `/`,
    })
    return {
      ...meta,
      links: [
        ...(meta.links ?? []),
        // Preload the hero (the LCP element) at the top of <head> so it's first
        // in the (simulated) critical path instead of being discovered after the
        // CSS + JS chain — that ordering was the whole LCP problem on mobile.
        // One per breakpoint via `media` so only the right one is fetched: the
        // portrait mobile shot below 640px, the landscape desktop shot above.
        {
          rel: `preload`,
          as: `image`,
          href: `/screenshots/trip-itinerary-mobile.webp`,
          media: `(max-width: 639px)`,
          fetchPriority: `high`,
        },
        {
          rel: `preload`,
          as: `image`,
          href: `/screenshots/trip-itinerary.webp`,
          media: `(min-width: 640px)`,
          fetchPriority: `high`,
        },
      ],
    }
  },
  component: HomePage,
})
